/* eslint-disable linebreak-style */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */

import React from 'react';
import { Fade } from 'react-awesome-reveal';
import Button from '../elements/Button';

// Import team member images
import CEO from '../assets/images/TeamMembers/CEO.jpg';
import ProjectManager from '../assets/images/TeamMembers/Project-manager.jpg';
import Frontend1 from '../assets/images/TeamMembers/Frontend1.jpg';
import Backend1 from '../assets/images/TeamMembers/Backend1.jpg';
import Mobile1 from '../assets/images/TeamMembers/Mobile1.jpg';
import UIUX1 from '../assets/images/TeamMembers/UIUX1.jpg';

const teamHighlights = [
  {
    name: 'Andy Duong',
    role: 'CEO & Founder',
    image: CEO,
    specialty: 'Strategy & Vision',
  },
  {
    name: 'Dylan Pham',
    role: 'CTO',
    image: ProjectManager,
    specialty: 'Product Management',
  },
  {
    name: 'Jim Hendrix',
    role: 'Lead Frontend',
    image: Frontend1,
    specialty: 'React & Mobile',
  },
  {
    name: 'Hawkins Jim',
    role: 'Lead Backend',
    image: Backend1,
    specialty: 'AI & Cloud',
  },
  {
    name: 'Bill Markinson',
    role: 'Mobile Lead',
    image: Mobile1,
    specialty: 'iOS & Android',
  },
  {
    name: 'Monica Lovegood',
    role: 'Design Lead',
    image: UIUX1,
    specialty: 'UI/UX Design',
  },
];

export default function TeamPreview() {
  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          {/* Left Content */}
          <div className="lg:w-1/2">
            <Fade direction="left" triggerOnce>
              <p className="text-sm font-medium text-theme-purple uppercase tracking-wider mb-3">
                Meet Our Team
              </p>
              <h2 className="text-4xl md:text-5xl text-theme-blue font-bold mb-6">
                People Behind
                <br />
                <span className="text-theme-purple">Our Success</span>
              </h2>
              <p className="text-lg text-gray-500 mb-8 leading-relaxed">
                Our diverse team of 20+ experts brings together world-class talent
                in AI, mobile development, and design. We are passionate about
                creating apps that make a difference.
              </p>

              {/* Team Stats */}
              <div className="grid grid-cols-3 gap-6 mb-8">
                <div>
                  <p className="text-3xl font-bold text-theme-blue">20+</p>
                  <p className="text-sm text-gray-500">Team Members</p>
                </div>
                <div>
                  <p className="text-3xl font-bold text-theme-blue">12</p>
                  <p className="text-sm text-gray-500">Countries</p>
                </div>
                <div>
                  <p className="text-3xl font-bold text-theme-blue">2</p>
                  <p className="text-sm text-gray-500">Years Exp</p>
                </div>
              </div>

              <Button
                href="/team"
                type="link"
                className="inline-flex items-center px-6 py-3 text-theme-purple font-medium border-2 border-theme-purple rounded-xl hover:bg-theme-purple hover:text-white transition-all duration-300 cursor-pointer"
              >
                Meet the Full Team
                <svg className="w-5 h-5 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </Button>
            </Fade>
          </div>

          {/* Right - Team Grid */}
          <div className="lg:w-1/2">
            <Fade direction="right" triggerOnce>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                {teamHighlights.map((member, index) => (
                  <Fade key={member.name} direction="up" delay={index * 100} triggerOnce>
                    <div className="group relative overflow-hidden rounded-2xl cursor-pointer">
                      {/* Image */}
                      <div className="aspect-[3/4] overflow-hidden">
                        <img
                          src={member.image}
                          alt={member.name}
                          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                        />
                      </div>

                      {/* Overlay on hover */}
                      <div className="absolute inset-0 bg-gradient-to-t from-theme-blue/90 via-theme-blue/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        <div className="absolute bottom-0 left-0 right-0 p-4">
                          <p className="text-white font-semibold">{member.name}</p>
                          <p className="text-white/80 text-sm">{member.role}</p>
                          <p className="text-theme-purple text-xs mt-1">{member.specialty}</p>
                        </div>
                      </div>

                      {/* Default name badge */}
                      <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3 group-hover:opacity-0 transition-opacity duration-300">
                        <p className="text-white text-sm font-medium">{member.name}</p>
                        <p className="text-white/70 text-xs">{member.role}</p>
                      </div>
                    </div>
                  </Fade>
                ))}
              </div>
            </Fade>
          </div>
        </div>
      </div>
    </section>
  );
}
